import { FC } from 'react';

import { Box } from '@bonusly/design-system';

/**
 * Falling Snow Effect
 * Creates gentle snowfall animation with white circles of varying sizes
 */
export const FallingSnow: FC = () => {
	// Generate 50 snow particles with randomized properties
	const items = Array.from({ length: 50 }, (_, i) => {
		const startX = Math.random() * 100;
		const duration = 12 + Math.random() * 18; // 12-30 seconds
		const delay = Math.random() * 25; // 0-25 second delay for stagger
		const size = 4 + Math.random() * 10; // 4-14px circles
		const swayAmount = 30 + Math.random() * 50; // 30-80px horizontal sway
		const opacity = 0.4 + Math.random() * 0.5; // 0.4-0.9 opacity

		return {
			id: i,
			startX,
			duration,
			delay,
			size,
			swayAmount,
			opacity,
		};
	});

	return (
		<Box position="fixed" top={0} left={0} right={0} width="100%" height="100vh" pointerEvents="none" zIndex={9999} overflow="hidden">
			<style>
				{`
					@keyframes snowfall {
						0% {
							transform: translateY(-100px) translateX(0);
							opacity: 0;
						}
						5% {
							opacity: var(--snow-opacity);
						}
						95% {
							opacity: var(--snow-opacity);
						}
						100% {
							transform: translateY(calc(100vh + 50px)) translateX(var(--sway-amount));
							opacity: 0;
						}
					}

					.winter-snowflake {
						position: absolute;
						top: -100px;
						background-color: white;
						border-radius: 50%;
						animation: snowfall var(--duration) linear var(--delay) infinite;
						will-change: transform, opacity;
					}
				`}
			</style>
			{items.map((item) => (
				<Box
					key={item.id}
					className="winter-snowflake"
					left={`${item.startX}%`}
					width={`${item.size}px`}
					height={`${item.size}px`}
					style={
						{
							'--duration': `${item.duration}s`,
							'--delay': `${item.delay}s`,
							'--sway-amount': `${item.swayAmount}px`,
							'--snow-opacity': item.opacity,
						} as React.CSSProperties
					}
				/>
			))}
		</Box>
	);
};
